// components/chat/chat-input/LexicalClearPlugin.tsx
import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot } from "lexical";

export const LexicalClearPlugin: React.FC<{
  clearTrigger: number;
}> = ({ clearTrigger }) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (clearTrigger > 0) {
      editor.update(() => {
        const root = $getRoot();
        root.clear();
      });
    }
  }, [clearTrigger, editor]);

  return null;
};
